export default "__VITE_ASSET__VXtnmcTe__"